module.exports = __webpack_public_path__ + "img/logo.762e1542.png";